// import * as Localization from 'expo-localization'
import memoize from 'lodash.memoize'
import i18n from 'i18n-js'
import dictionary_en from './dictionary_en.json'
import dictionary_es from './dictionary_es.json'

const getDictionary = (lang) => {
  switch(lang) {
    case 'en':
    default:
      return dictionary_en
    case 'es':
      return dictionary_es
  }
}

const translationGetters = {
  en: () => getDictionary('en'),
  es: () => getDictionary('es'),
}

export const translate = memoize(
  (key, config) => i18n.t(key, config),
  (key, config) => (config ? key + JSON.stringify(config) : key),
)

export const getLocale = () => i18n.locale
export const getDayRefFormat = (locale = getLocale()) => {
  switch (locale) {
    case 'es':
      return 'DD [de] MMMM'
    default:
      return 'MMMM Do'
  }
}

// in Spanish verbs in past participle are pluralizable meanwhile in English they aren't.
// currently only en is not pluralizeble.
export const isPastParticiplePluralizable = (locale = getLocale()) =>
  ({
    en: false,
    es: true,
  }[locale])

export const setI18nConfig = async (callback) => {
  // fallback if no available language fits
  const fallback = 'en'

  // const { locale: localeComplete } = await Localization.getLocalizationAsync()
  let locale = navigator.language.substring(0, 2)

  if (!Object.keys(translationGetters).includes(locale)) locale = fallback

  const languageTag = locale

  const dictionary = await translationGetters[languageTag]()
  // set i18n-js config
  // clear translation cache
  // if (translate.cache.clear) translate.cache.clear()
  i18n.translations = { [languageTag]: dictionary }
  i18n.locale = languageTag
  callback(true)
}
